module.exports = __webpack_public_path__ + "static/media/2.98d95641.jpg";